import {
    displayName,
    formatDateInEN,
    getCurrentTimestamp,
    isNullOrEmpty,
} from "../../../../../commons/util/HallAppUtil";
import { useEffect, useMemo, useState } from "react";

import AppButton from "../../../../../commons/buttons/AppButton";
import AppContainer from "../../../../../commons/containers/AppContainer";
import AppInput from "../../../../../commons/inputs/AppInput";
import AppLinkButton from "../../../../../commons/buttons/AppLinkButton";
import CalendarInput from "../../../../../commons/inputs/CalendarInput";
import CompanyAPI from "../../../../company/CompanyAPI";
import HallAppToast from "../../../../../commons/HallAppToast";
import Select from "react-select";
import ServiceAPI from "../../../../services/ServiceAPI";

const serviceAPI = new ServiceAPI();
  const companyAPI = new CompanyAPI();
  
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: 56,
      borderRadius: 14,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  
  function ARStep3({ nextStep, toBack }) {
    const [durationRecurrence, setDurationRecurrence] = useState(null); // REPETITION | SPECIFIC_DATE | INFINITE?
    const [duration, setDuration] = useState(null); // repetições
    const [startDate, setStartDate] = useState(new Date());
    const [serviceDate, setServiceDate] = useState(null); // specificDate
  
    const [services, setServices] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [serviceProfessionalMap, setServiceProfessionalMap] = useState({});
  
    useEffect(() => {
      findAllServices();
      getAllEmployee();
    }, []);
  
    const findAllServices = async () => {
      try {
        const response = await serviceAPI.findAllByCompanyId(companyAPI.getCompanyManagment().id);
        if (response.data) {
          response.data.sort((a, b) => a.categoryName.localeCompare(b.categoryName));
          const options = response.data.map((d) => ({ value: d.id, label: d.name }));
          setServices(options);
        }
      } catch (_) {
        setServices([]);
      }
    };
  
    const getAllEmployee = async () => {
      try {
        const response = await companyAPI.getAllEmployee(companyAPI.getCompanyManagment().id);
        const options = response.data.map((d) => ({
          value: d.id,
          label: displayName(d.name) || d.email,
          key: getCurrentTimestamp(),
        }));
        setEmployees(options);
      } catch (_) {
        setEmployees([]);
      }
    };
  
    const isRepetition = durationRecurrence === "REPETITION";
    const isSpecificDate = durationRecurrence === "SPECIFIC_DATE";
  
    const selectedServicesLabel = useMemo(() => {
      if (!selectedServices?.length) return "Nenhum serviço selecionado";
      if (selectedServices.length === 1) return selectedServices[0].label;
      return `${selectedServices.length} serviços selecionados`;
    }, [selectedServices]);
  
    function handleChangeDate(date) {
      setServiceDate(date);
    }
  
    const validate = () => {
      if (isNullOrEmpty(durationRecurrence)) {
        HallAppToast.error("Selecione a duração da recorrência.");
        return false;
      }
  
      if (isRepetition && (isNullOrEmpty(duration) || Number(duration) <= 0)) {
        HallAppToast.error("Informe a quantidade de repetições.");
        return false;
      }
  
      if (isSpecificDate && isNullOrEmpty(serviceDate) && isNullOrEmpty(startDate)) {
        // serviceDate vem do CalendarInput via changeDates; startDate é o state do calendário
        HallAppToast.error("Selecione a data final.");
        return false;
      }
  
      if (!selectedServices || selectedServices.length === 0) {
        HallAppToast.error("Selecione pelo menos um serviço.");
        return false;
      }
  
      const missingProfessional = selectedServices.some(s => !serviceProfessionalMap[s.value]);
      if (missingProfessional) {
        HallAppToast.error("Selecione o profissional para todos os serviços.");
        return false;
      }
  
      return true;
    };
  
    const toNext = () => {
      if (!validate()) return;
  
      const payload = selectedServices.map((service) => {
        const employeeId = serviceProfessionalMap[service.value] || null;
        const professional = employees.find((emp) => emp.value === employeeId);
  
        return {
          serviceId: service.value,
          serviceName: service.label,
          employeeId,
          employeeName: professional?.label || null,
        };
      });
  
      const data = {
        services: payload,
        durationRecurrence,
        duration: isRepetition ? duration : null,
        specificDate: isSpecificDate ? (serviceDate || formatDateInEN(new Date(startDate))) : null,
      };
  
      nextStep(data);
    };
  
    return (
      <div style={{ paddingBottom: 90 }}>
        {/* Cabeçalho */}
        <div className="mb-3">
          <div style={{ fontSize: 16, fontWeight: 700, lineHeight: "20px" }}>Duração e atendimentos</div>
          <div className="text-muted" style={{ fontSize: 12 }}>
            Defina até quando a recorrência acontece e quem vai atender.
          </div>
        </div>
  
        {/* Card: Duração */}
        <div
          style={{
            background: "#fff",
            border: "1px solid #eee",
            borderRadius: 16,
            padding: 14,
            marginBottom: 12,
          }}
        >
          <div className="mb-2" style={{ fontSize: 14, fontWeight: 700 }}>
            Até quando acontece?
          </div>
          <div className="text-muted mb-3" style={{ fontSize: 12 }}>
            Escolha por repetições ou até uma data.
          </div>
  
          <div className="d-flex flex-column gap-2">
            <button
              type="button"
              onClick={() => {
                setDurationRecurrence("REPETITION");
                setServiceDate(null);
              }}
              style={{
                borderRadius: 14,
                border: durationRecurrence === "REPETITION" ? "2px solid #2f2a7a" : "1px solid #e8e8f0",
                background: durationRecurrence === "REPETITION" ? "#f1f3ff" : "#fff",
                padding: "12px 12px",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 800, color: "#1d1b4a" }}>Por repetições</div>
              <div className="text-muted" style={{ fontSize: 11 }}>
                Ex: 10 vezes
              </div>
            </button>
  
            {isRepetition && (
              <div className="mt-2">
                <AppInput
                  label="Quantidade de repetições"
                  name="duration"
                  type="number"
                  errors={[]}
                  value={duration || ""}
                  onChange={(e) => setDuration(e.target.value)}
                  placeholder="Ex: 10"
                />
              </div>
            )}
  
            <button
              type="button"
              onClick={() => {
                setDurationRecurrence("SPECIFIC_DATE");
                setDuration(null);
              }}
              style={{
                borderRadius: 14,
                border: durationRecurrence === "SPECIFIC_DATE" ? "2px solid #2f2a7a" : "1px solid #e8e8f0",
                background: durationRecurrence === "SPECIFIC_DATE" ? "#f1f3ff" : "#fff",
                padding: "12px 12px",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 800, color: "#1d1b4a" }}>Até uma data</div>
              <div className="text-muted" style={{ fontSize: 11 }}>
                Ex: 30/09/2027
              </div>
            </button>
  
            {isSpecificDate && (
              <div className="mt-2">
                <div className="text-muted mb-2" style={{ fontSize: 12 }}>
                  Data final <span style={{ color: "red" }}>*</span>
                </div>
  
                <div className="commando-form-service-date" style={{ marginBottom: 8 }}>
                  <CalendarInput
                    selectionMode="single"
                    setDates={setStartDate}
                    changeDates={handleChangeDate}
                    values={startDate}
                  />
                </div>
  
                <div className="text-muted" style={{ fontSize: 11 }}>
                  A recorrência será criada até a data selecionada.
                </div>
              </div>
            )}
          </div>
        </div>
  
        {/* Card: Serviço/Profissional */}
        <div
          style={{
            background: "#fff",
            border: "1px solid #eee",
            borderRadius: 16,
            padding: 14,
            marginBottom: 12,
          }}
        >
          <div className="mb-2" style={{ fontSize: 14, fontWeight: 700 }}>
            Serviço e profissional
          </div>
          <div className="text-muted mb-3" style={{ fontSize: 12 }}>
            Selecione os serviços e, se quiser, defina um profissional para cada um.
          </div>
  
          <div style={{ marginBottom: 10 }}>
            <Select
              styles={customStyles}
              options={services}
              isClearable
              isSearchable
              isMulti
              placeholder="Selecione os serviços"
              onChange={(selectedOptions) => {
                const nextSelected = selectedOptions || [];
                setSelectedServices(nextSelected);
  
                // limpa mapa de profissionais de serviços removidos
                const nextMap = { ...serviceProfessionalMap };
                Object.keys(nextMap).forEach((serviceId) => {
                  const stillSelected = nextSelected.some((s) => String(s.value) === String(serviceId));
                  if (!stillSelected) delete nextMap[serviceId];
                });
                setServiceProfessionalMap(nextMap);
              }}
              value={selectedServices}
            />
            <div className="text-muted" style={{ fontSize: 11, marginTop: 6 }}>
              {selectedServicesLabel}
            </div>
          </div>
  
          {/* Lista de serviços selecionados */}
          <div className="d-flex flex-column gap-2">
            {selectedServices.map((service) => (
              <div
                key={service.value}
                style={{
                  border: "1px solid #eee",
                  borderRadius: 14,
                  padding: "10px 10px",
                  background: "#fafafa",
                }}
              >
                <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                  <div style={{ fontWeight: 800, fontSize: 13, color: "#1d1b4a" }}>
                    {service.label}
                  </div>
  
                  <div style={{ minWidth: 260, width: "100%" }}>
                    <Select
                      placeholder="Selecione o profissional (opcional)"
                      options={employees}
                      styles={{
                        ...customStyles,
                        container: (base) => ({ ...base, width: "100%" }),
                        control: (base) => ({ ...base, minHeight: 48, borderRadius: 14 }),
                      }}
                      value={employees.find((e) => e.value === serviceProfessionalMap[service.value]) || null}
                      onChange={(selectedEmployee) => {
                        setServiceProfessionalMap((prev) => ({
                          ...prev,
                          [service.value]: selectedEmployee?.value || null,
                        }));
                      }}
                      isClearable
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
  
          {selectedServices.length === 0 && (
            <div className="text-muted" style={{ fontSize: 12, marginTop: 6 }}>
              Selecione um ou mais serviços para continuar.
            </div>
          )}
        </div>
  
        {/* Footer actions */}
        <div
          className="ar-footer-actions"
          style={{
            position: "sticky",
            bottom: 0,
            padding: "10px 0",
            background: "linear-gradient(to top, #fff 70%, rgba(255,255,255,0))",
            borderTop: "1px solid #eee",
          }}
        >
          <AppContainer>
            <AppLinkButton fullWidth={true} name="Próximo" width="100%" onClick={toNext} />
  
            <div style={{ marginTop: 10 }}>
              <AppButton name="Voltar" width="100%" onClick={toBack} />
            </div>
          </AppContainer>
        </div>
      </div>
    );
  }
  
  export default ARStep3;
  